import React from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';

import Form from '../Form';

class SelectionTemplateCreationForm extends Form {
    static fieldsValidation = {
        name: ['required'],
    };

    static propTypes = {
        ...Form.propTypes,
        onSubmit: PropTypes.func,
    };

    static defaultProps = {
        ...Form.defaultProps,

        eventTemplates: List(),
    };

    constructor(props, context) {
        super(props, context);
    }

    onSubmit(event) {
        event.preventDefault();

        Form.prototype.onSubmit.call(this, event);
    }

    renderForm() {
        return (
            <div className='selection-template-creation'>
                {this.getField(
                    <input
                        type='text'
                        label='Selection Name'
                        {...this.getFieldParameters('name')}
                    />,
                    'You can use the following placeholders in name ' +
                        '${player} ${homesubparticipant} ' +
                        '${awaysubparticipant} ${home} ${away} ' +
                        '${line} ${opposite-line}'
                )}

                <button
                    onClick={this.onSubmit.bind(this)}
                    className='btn btn-add'
                >
                    Save selection template
                </button>
            </div>
        );
    }
}

export default SelectionTemplateCreationForm;
